import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import checkImagePlaceholder from "../../CallToAction/CardCallToAction/check_image_placeholder.png";
import heartImagePlaceholder from "../../CallToAction/CardCallToAction/heart_image_placeholder.png";
import trophyImagePlaceholder from "../../CallToAction/CardCallToAction/trophy_image_placeholder.png";
import usersImagePlaceholder from "../../CallToAction/CardCallToAction/users_image_placeholder.png";
import { getSalesBlockPrimaryStyleOptions } from "../../Sales/constants";
import { createCardBlock } from "../../utils/layoutBlockHelpers";
import {
  createBadgeBlock,
  createH2Block,
  createH3Block,
  createPBlock,
} from "../../utils/textBlocksHelpers";

const cards = [
  {
    image: {
      signedId: "",
      placeholder: heartImagePlaceholder,
    },
    h5Text: "Integrity",
    pText:
      "Maintaining the highest ethical standards and always acting in the best interest of my clients.",
  },
  {
    image: {
      signedId: "",
      placeholder: trophyImagePlaceholder,
    },
    h5Text: "Excellence",
    pText:
      "Continuously improving my methods and knowledge to provide exceptional coaching experiences.",
  },
  {
    image: {
      signedId: "",
      placeholder: usersImagePlaceholder,
    },
    h5Text: "Empowerment",
    pText:
      "Building self-reliance and capability in clients rather than creating dependency.",
  },
  {
    image: {
      signedId: "",
      placeholder: checkImagePlaceholder,
    },
    h5Text: "Authenticity",
    pText:
      "Encouraging genuine self expression and alignment with one's true values and purpose.",
  },
] as const;

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "AboutUsBlock4",
  meta: {},
  props: {
    header: {
      meta: {
        category: [],
        name: "Header",
        nameI18n: "builder_ui.prop_type.header",
      },
      prop: "children",
      type: "children",
      value: [
        createBadgeBlock({
          text: "Mission & Values",
        }),
        createH2Block({
          text: "What drives us",
        }),
        createPBlock({
          text: "The core principles that guide my coaching practice",
        }),
      ],
    },
    content: {
      meta: {
        category: [],
        name: "Content",
        nameI18n: "builder_ui.prop_type.content",
      },
      prop: "children",
      type: "children",
      value: [
        createH3Block({
          text: "Our mission",
        }),
        createPBlock({
          text: "To empower individuals and organizations to discover their unique potential, overcome limitations, and create extraordinary results through transformative coaching and evidence-based strategies.",
          paragraphStyle: "p3",
        }),
      ],
    },
    cards: {
      meta: {
        category: [],
        name: "Cards",
        nameI18n: "builder_ui.prop_type.cards",
      },
      prop: "children",
      type: "children",
      value: cards.map(card => createCardBlock(card)),
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getSalesBlockPrimaryStyleOptions(),
      },
      meta: {
        name: "Styles",
        nameI18n: "builder_ui.prop_type.styles",
        category: [],
      },
    },
  },
};
